import { useState } from "react";
import { __ } from "@wordpress/i18n";
import Astra_Admin_Icons from "@Common/block-icons";
import ReactHtmlParser from "react-html-parser";

const SubSection = ({ item }) => {
	const [categorySlug, category] = item;
	const [open, setOpen] = useState(false);

	// Subcategories.
	const subcategories = Object.entries(category.subcategories);

	// Docs.
	const docs = astra_admin.astra_docs_data.docs.filter(
		(doc) => doc.category?.toString() === categorySlug
	);

	const docsCount = docs.length;

	return (
		<div className="py-5 border-t border-slate-200">
			<button
				onClick={() => setOpen(!open)}
				className="w-full flex justify-between items-center"
			>
				<div className="flex items-center">
					{Astra_Admin_Icons["bookmark"]}

					<h4 className="text-base font-medium leading-[1.625rem] text-slate-800 ml-2">
						{ReactHtmlParser(category.name)}
					</h4>
				</div>
				<div
					className={` ${
						open ? "rotate-0" : "-rotate-90"
					} transition-rotate duration-300 ease-in-out`}
				>
					{Astra_Admin_Icons["expand"]}
				</div>
			</button>

			{/* Sub Section Items */}
			{open && (
				<div className="mt-5">
					{/* Sub Categories */}
					{!!subcategories.length && (
						<div className="ml-2">
							{subcategories.map((subItem, key) => (
								<SubSection item={subItem} key={key} />
							))}
						</div>
					)}

					{!!docs.length && (
						<>
							<div className="space-y-1 mb-5">
								{/* Single Item */}
								{docs.splice(0, 5).map((doc, key) => (
									<a
										href={
											doc.url +
											"?utm_source=free-theme&utm_medium=dashboard&utm_campaign=knowledge"
										}
										target="_blank"
										className="flex items-center justify-between text-slate-800 rounded-md p-2 pl-0 hover:bg-gray-50 group cursor-pointer focus:outline-0"
										key={key}
									>
										<div className="flex items-center ast-kb-caret">
											<span>
												{Astra_Admin_Icons["caret"]}
											</span>

											<div className="text-base leading-[1.625rem] text-slate-800 ml-2">
												{ReactHtmlParser(doc.title)}
											</div>
										</div>
										<div className="text-slate-600 invisible group-hover:visible">
											{Astra_Admin_Icons["redirect"]}
										</div>
									</a>
								))}
							</div>

							<a
								href={ astra_admin.websiteUrl?.docsCategoryDynamicUrl?.replace( '#category#', categorySlug ) }
								target="_blank"
								className="text-base font-medium leading-4 text-astra flex items-center"
							>
								<span className="mr-2">
									{`View all ${ReactHtmlParser(
										category.name
									)} docs`}
								</span>
								{Astra_Admin_Icons["redirect"]}
							</a>
						</>
					)}

					{!docsCount && !subcategories.length && (
						<p>{__("No docs found!", "astra")}</p>
					)}
				</div>
			)}
		</div>
	);
};

export default SubSection;
